export const globalMixin = {
  computed: {
    screenWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%'
        case 'sm': return '100%'
        case 'md': return '100%'
        case 'lg': return '95%'
        case 'xl': return '70%'
        default: return '100%'
      }
    }
  }
}
